import Residential_buyer from "src/assets/images/contact/Residential_buyer.svg";
import Residential_landlord from "src/assets/images/contact/Residential_landlord.svg";
import Residential_seller from "src/assets/images/contact/Residential_seller.svg";
import Residential_tenant from "src/assets/images/contact/Residential_tenant.svg";
import Commercial_buyer from "src/assets/images/contact/commercial_buyer.svg";
import Commercial_landlord from "src/assets/images/contact/commercial_landloard.svg";
import Commercial_seller from "src/assets/images/contact/commercial_seller.svg";
import Commercial_tenant from "src/assets/images/contact/commercial_tenant.svg";

export const colourOptions = [
  { value: "ocean", label: "Ocean", color: "#00B8D9", isFixed: true },
  { value: "blue", label: "Blue", color: "#0052CC", disabled: true },
  { value: "purple", label: "Purple", color: "#5243AA" },
  { value: "red", label: "Red", color: "#FF5630", isFixed: true },
  { value: "orange", label: "Orange", color: "#FF8B00" },
  { value: "yellow", label: "Yellow", color: "#FFC400" },
  { value: "green", label: "Green", color: "#36B37E" },
  { value: "forest", label: "Forest", color: "#00875A" },
  { value: "slate", label: "Slate", color: "#253858" },
  { value: "silver", label: "Silver", color: "#666666" },
];

export const flavourOptions = [
  { value: "vanilla", label: "Vanilla", rating: "safe" },
  { value: "chocolate", label: "Chocolate", rating: "good" },
  { value: "strawberry", label: "Strawberry", rating: "wild" },
  { value: "salted-caramel", label: "Salted Caramel", rating: "crazy" },
];

export const stateOptions = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AS", label: "American Samoa" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "DC", label: "District Of Columbia" },
  { value: "FM", label: "Federated States Of Micronesia" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "GU", label: "Guam" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MH", label: "Marshall Islands" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "MP", label: "Northern Mariana Islands" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PW", label: "Palau" },
  { value: "PA", label: "Pennsylvania" },
  { value: "PR", label: "Puerto Rico" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VI", label: "Virgin Islands" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];

export const optionLength = [
  { value: 1, label: "general" },
  {
    value: 2,
    label:
      "Evil is the moment when I lack the strength to be true to the Good that compels me.",
  },
  {
    value: 3,
    label:
      "It is now an easy matter to spell out the ethic of a truth: 'Do all that you can to persevere in that which exceeds your perseverance. Persevere in the interruption. Seize in your being that which has seized and broken you.",
  },
];

// let bigOptions = [];
// for (let i = 0; i < 10000; i++) {
// 	bigOptions = bigOptions.concat(colourOptions);
// }

export const groupedOptions = [
  {
    label: "Colours",
    options: colourOptions,
  },
  {
    label: "Flavours",
    options: flavourOptions,
  },
];

export const leadStatusOption = [
  { value: "new", label: "New" },
  { value: "waiting-on-contact", label: "Waiting On Contact" },
  { value: "waiting-on-us", label: "Waiting On Us" },
  { value: "closed", label: "Closed" },
  { value: "merged", label: "Merged" },
];

export const sourceList = [
  { value: "Website", label: "Website" },
  { value: "Whatsapp", label: "Whatsapp" },
  { value: "Facebook", label: "Facebook" },
  { value: "Instagram", label: "Instagram" },
  { value: "Telegram", label: "Telegram" },
  { value: "Walk-in", label: "Walk-in" },
  // { value: "Google-ads", label: "Google-ads" },
  // { value: "Marketing-site", label: "Marketing-site" },
];

export const leadOwnerList = [
  { value: "Gaurav Lalwani", label: "Gaurav Lalwani" },
  { value: "Sachin Kumar", label: "Sachin Kumar" },
];

export const priorityList = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
];

export const reviewOptions2 = [
  { value: "Sales", label: "Sales" },
  { value: "Lettings", label: "Lettings" },
  { value: "Customer Support", label: "Customer Support" },
];

export const statusOptions = [
  { value: 1, label: "Active" },
  { value: 0, label: "In-Active" },
];

export const departmentType = [
  { value: "residential", label: "Residential" },
  { value: "commercial", label: "Commercial" },
  { value: "both", label: "Both" },
];

export const propertyType = [
  { value: "residential", label: "Residential" },
  { value: "commercial", label: "Commercial" },
];

export const departmentRole = [
  { value: "sales", label: "Sales" },
  { value: "lettings", label: "Lettings" },
  { value: "both", label: "Both" },
];

export const titles = [
  { value: "Mr.", label: "Mr." },
  { value: "Miss.", label: "Miss." },
  { value: "Dr.", label: "Dr." },
];

export const agentTypes = [
  { value: "companymanager", label: "Manager" },
  { value: "agent", label: "Agent" },
];

export const RolesForSuperAdmin = [
  { value: "all", label: "All" },
  { value: "companyadmin", label: "Company Admin" },
  { value: "companymanager", label: "Company Manager" },
  { value: "agent", label: "Agent" },
];

export const RolesForCompanyAdmin = [
  { value: "all", label: "All" },
  { value: "companymanager", label: "Company Manager" },
  { value: "agent", label: "Agent" },
];

export const TypesForSuperAdmin = [
  { value: "companyadmin", label: "Company Admin" },
  { value: "companymanager", label: "Company Manager" },
  { value: "agent", label: "Agent" },
];

export const TypesForCompanyAdmin = [
  { value: "companymanager", label: "Company Manager" },
  { value: "agent", label: "Agent" },
];

export const RowsPerPageList = [
  { value: 5, label: "5" },
  { value: 10, label: "10" },
  { value: 20, label: "20" },
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 75, label: "75" },
  { value: 100, label: "100" },
];

export const contactCategory = [
  { label: "Residential Sales", value: "residential-sales" },
  { label: "Residential Lettings", value: "residential-lettings" },
  { label: "Residential Support", value: "residential-support" },
  { label: "Commercial Sales", value: "commercial-sales" },
  { label: "Commercial Lettings", value: "commercial-lettings" },
  { label: "Commercial Support", value: "commercial-support" },
];

export const agentType = [
  { label: "Buyer", value: "buyer", type: "sales" },
  { label: "Seller", value: "seller", type: "sales" },
  { label: "Landlord", value: "landlord", type: "lettings" },
  { label: "Tenant", value: "tenant", type: "lettings" },
];

export const LeadStatus = [
  { label: "New", value: "New" },
  { label: "Open", value: "Open" },
  { label: "In progress", value: "In progress" },
  { label: "Open Deal", value: "Open Deal" },
  { label: "Unqualified", value: "Unqualified" },
  { label: "Attempt to contact", value: "Attempt to contact" },
  { label: "Connected", value: "Connected" },
  { label: "Bad timings", value: "Bad timings" },
];

export const AssociateData = [
  {
    label: "Contact",
    value: "Contact",
  },
  {
    label: "Leads",
    value: "Leads",
  },
];

export const TodoType = [
  {
    label: "Call",
    value: "Call",
  },
  {
    label: "Email",
    value: "Email",
  },
  {
    label: "Meeting",
    value: "Meeting",
  },
  {
    label: "Todo",
    value: "Todo",
  },
];

export const PriorityList = [
  {
    label: "High",
    value: "high",
  },
  {
    label: "Low",
    value: "low",
  },
  {
    label: "Medium",
    value: "medium",
  },
];

export const ReminderList = [
  {
    label: "No reminder",
    value: "No Reminder",
  },
  {
    label: "At task due time",
    value: "At task due time",
  },
  {
    label: "30 min before",
    value: "30 Min before",
  },
  {
    label: "1 day before",
    value: "1 day before",
  },
];

export const TodoTitle = [
  {
    label: "Appointment",
    value: "appointment",
  },
  {
    label: "Task",
    value: "task",
  },
];

export const filterTypes = [
  { value: "today", label: "Today" },
  { value: "week", label: "Week" },
  { value: "month", label: "Month" },
];

export const ContactData = [
  { value: "today", label: "Today" },
  { value: "week", label: "Week" },
];

export const todoStatus = [
  { value: "pending", label: "Pending" },
  { value: "important", label: "Important" },
  { value: "completed", label: "Completed" },
];

export const leadMotive = [
  { value: "Buying", label: "Buy" },
  { value: "Selling", label: "Sell" },
  { value: "Lettings", label: "Lettings" },
  { value: "Others", label: "Others" },
];

export const customerCategory = [
  { value: "buyer", label: "Buyer" },
  { value: "seller", label: "Seller" },
  { value: "landlord", label: "Landlord" },
  { value: "tenant", label: "Tenant" },
];

export const outcomesDataForMeetingLog = [
  { value: "Scheduled", label: "Scheduled" },
  { value: "Completed", label: "Completed" },
  { value: "Rescheduled", label: "Rescheduled" },
  { value: "No Show", label: "No Show" },
  { value: "Cancelled", label: "Cancelled" },
];

export const outcomesDataForCallLog = [
  { value: "Busy", label: "Busy" },
  { value: "Connected", label: "Connected" },
  { value: "Left Live Message", label: "Left Live Message" },
  { value: "Left Voicemail", label: "Left Voicemail" },
  { value: "No Answer", label: "No Answer" },
  { value: "Wrong Number", label: "Wrong Number" },
];

export const leadFilterOption = [
  { value: "Chat", label: "Chats" },
  { value: "Note", label: "Notes" },
  { value: "Task", label: "Tasks" },
  { value: "Appointment", label: "Appointments" },
  { value: "Log", label: "Logs" },
  { value: "Activity", label: "Lead Activities" },
];

export const WaitingTime = [
  { label: "1 minute", value: 1, visible: false },
  { label: "2 minutes", value: 2, visible: true },
  { label: "3 minutes", value: 3, visible: true },
  { label: "4 minutes", value: 4, visible: true },
  { label: "5 minutes", value: 5, visible: true },
];

export const genderOptions = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
];

export const categories = [
  {
    label: "Residential Seller",
    value: "residential-seller",
    color: "#2962FF",
    icon: Residential_seller
  },
  {
    label: "Residential Buyer",
    value: "residential-buyer",
    color:"#3699FF",
    icon: Residential_buyer
  },
  {
    label: "Residential Tenant",
    value: "residential-tenant",
    color:"#F64E60",
    icon: Residential_tenant
  },
  {
    label: "Residential Landlord",
    value: "residential-landlord",
    color:"#0BB7AF",
    icon: Residential_landlord
  },
  {
    label: "Commercial Seller",
    value: "commercial-seller",
    color:"#EE9D01",
    icon: Commercial_seller
  },
  {
    label: "Commercial Buyer",
    value: "commercial-buyer",
    color:"#001E3C",
    icon: Commercial_buyer
  },
  {
    label: "Commercial Tenant",
    value: "commercial-tenant",
    color:"#57BC46",
    icon: Commercial_tenant
  },
  {
    label: "Commercial Landlord",
    value: "commercial-landlord",
    color:"#9D51FE",
    icon: Commercial_landlord
  },
];

export const calendarTypes = [
  { label: "Team Calendar", value: "team" },
  { label: "My Calendar", value: "my" },
];

export const leadTypes = [
  { label: "Team Leads", value: "team" },
  { label: "My Leads", value: "my" },
];


export const noOfBrach=[
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10", value: 10 },
  // { label: "11", value: 11 },
  // { label: "12", value: 12 },
  // { label: "13", value: 13 },
  // { label: "14", value: 14 },
  // { label: "15", value: 15 },
  // { label: "16", value: 16 },
  // { label: "17", value: 17 },
  // { label: "18", value: 18 },
  // { label: "19", value: 19 },
  // { label: "20", value: 20 }
];

export const trialPeriod=[
  { label: "0", value: 0 },
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
]
